import React, { Component } from 'react'

import Giphy from './giphy'

import Textarea from 'react-textarea-autosize'
import Picker from 'emoji-picker-react'

import GifIcon from 'images/icons/gif.jsx'

import Button from 'components/button/button'

import { debounce } from 'lodash'

import {
	isMobile,
	getFileFromCamera,
	getCaretPosition,
	doDirtyInput,
	doClickEventListeners
} from 'utils'

import isEqual from 'react-fast-compare'

export default class DockChatInput extends Component {
	state = {
		inputValue: ''
	}

	constructor(props) {
		super(props)

		this.debouncedSetTyping = debounce(this.handleDebouncedSetTyping, 300)
	}

	shouldComponentUpdate = (nextProps, nextState) => {
		const isAllEqual = isEqual(this.props, nextProps) && isEqual(this.state, nextState)

		return !isAllEqual
	}

	componentDidUpdate = _ => {
		window.requestAnimationFrame(_ => {
			if (this.inputContainer) {
				const newChatHeight = this.inputContainer.getBoundingClientRect().height
				const oldChatHeight = this.props.inputsHeight

				if (newChatHeight !== oldChatHeight) {
					this.props.updateInputsHeight(newChatHeight)
				}
			}
		})
	}

	handleClickOutside = e => {
		const {
			openCallout,
			toggleEmojis,
			toggleGiphy
		} = this.props

		if (!openCallout) {
			return
		}

		const refElement = this[openCallout + 'Ref']

		if (!refElement) {
			return
		}

		if (!e || !refElement.contains(e.target)) {
			if (openCallout === 'emoji') {
				toggleEmojis()
			} else {
				toggleGiphy()
			}
		}
	}

	componentDidMount = _ => {
		doClickEventListeners(this.handleClickOutside)
	}

	componentWillUnmount() {
		const {
			chatObject
		} = this.props

		doDirtyInput('remove', 'chat-' + chatObject.id)
		doClickEventListeners(this.handleClickOutside, true)
	}

	handleChange = value => {
		const {
			chatObject
		} = this.props

		this.debouncedSetTyping()

		var newline = String.fromCharCode(13, 10)
		value = value.replace(/(?:\r\n|\r|\n)/g, newline)

		doDirtyInput(value ? 'add' : 'remove', 'chat-' + chatObject.id)

		this.setState({
			inputValue: value
		})
	}

	handleDebouncedSetTyping = () => {
		const {
			setTyping
		} = this.props

		if (this.messageInput) {
			setTyping(!!this.messageInput.value.length)
		}
	}

	selectEmoji = (event, emojiObject) => {
		this.props.toggleEmojis()

		const emoji = emojiObject.emoji

		let currentText = this.state.inputValue

		let caretPosition = getCaretPosition(this.messageInput)

		currentText = currentText ? currentText.slice(0, caretPosition.start) + emoji + currentText.slice(caretPosition.start) : emoji

		this.setState({
			inputValue: currentText
		})
	}

	selectGiphy = (giphyObject) => {
		this.props.toggleGiphy()

		const giphy = '<img src="' + giphyObject.images.downsized.url + '" />'

		let currentText = this.state.inputValue

		let caretPosition = getCaretPosition(this.messageInput)

		currentText = currentText ? currentText.slice(0, caretPosition.start) + giphy + currentText.slice(caretPosition.start) : giphy

		this.setState({
			inputValue: currentText
		})

		setTimeout(_ => {
			this.sendMessage()
		})
	}

	handleTextareaKeyPress = e => {
		const {
			handleFocusChange
		} = this.props

		handleFocusChange(true)

		if (!isMobile()) {
			if (e.key === 'Enter') {
				if (!e.shiftKey) {
					e.preventDefault()

					this.sendMessage()
				}
			}
		}
	}

	sendMessage = _ => {
		this.props.sendMessage()

		setTimeout(_ => {
			this.setState({
				inputValue: ''
			})
		})
	}

	render() {
		const {
			handleFocusChange,
			chatObject,
			uploadFile,
			openCallout,
			optimistic,
			isTeamChat,
			toggleEmojis,
			toggleGiphy,
			userData,
			hasMounted,
			isBigChat,
		} = this.props

		const {
			inputValue
		} = this.state

		return (
			<div className="input-container" ref={ref => this.inputContainer = ref}>
				<Textarea
					disabled={(optimistic || (chatObject.userIds && chatObject.userIds.length < 2)) && !isTeamChat}
					onChange={e => { this.handleChange(e.target.value) }}
					onFocus={_ => {
						handleFocusChange(true)
					}}
					onBlur={_ => {
						handleFocusChange(false)
					}}
					inputRef={ref => { this.messageInput = ref }}
					placeholder="Write your message here."
					onKeyPress={this.handleTextareaKeyPress}
					value={inputValue}
					rows={1}
					useCacheForDOMMeasurements={true}
				/>
				<div className="chat-inputs">
					<div className="input-buttons" ref={ref => { this.buttonContainerRef = ref }}>
						{
							!isMobile() ?
								<Button icon="smile-o" callback={toggleEmojis} />
								:
								<Button icon="camera" callback={_ => {
									getFileFromCamera(uploadFile, userData)
								}} />
						}
						<Button
							callback={toggleGiphy}
							svgIcon={GifIcon}
						/>
						<Button
							callback={uploadFile}
							icon={'paperclip'}
							hasFile={true}
						/>
					</div>
					{hasMounted ?
						<React.Fragment>
							{!isMobile() ?
								<div
									ref={ref => { this.emojiRef = ref }}
									className={`emojis-popup ${openCallout === 'emoji' ? 'visible' : ''}`}
								>
									<Picker
										onEmojiClick={this.selectEmoji}
										disableAutoFocus={true}
										native
									/>
								</div>
								:
								null}
							<div
								ref={ref => { this.giphyRef = ref }}
								className={`giphy-popup ${openCallout === 'giphy' ? 'visible' : ''}`}
							>
								<Giphy
									selectGiphy={this.selectGiphy}
									isBigChat={isBigChat}
									openCallout={openCallout}
								/>
							</div>
						</React.Fragment>
						: null}
					<button
						disabled={!inputValue}
						onClick={this.sendMessage}
						className="send-button"
					>
						Send
					</button>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/layout/dock/dock-chat-input.jsx